import Util from "./Util.js";
//
import { gsap } from "./Util.js";

class Cart extends Util {
  constructor() {
    super();
    this.cart = [];
    this.isCartPage = window.location.pathname === "/cart";
    console.log("Cartクラス初期化:", {
      isCartPage: this.isCartPage,
      pathname: window.location.pathname,
    });
    this.init();
  }

  init() {
    this.bindEvents();
    this.loadCart();

    // カートページの場合は追加の初期化
    if (this.isCartPage) {
      this.initCartPage();
    }
  }

  initCartPage() {
    // カートページの初期化
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.setupCartPageEvents();
        this.fetchCartAndUpdateCount();
        this.updateCartPageButtonsState();
      });
    } else {
      // DOMが既に読み込まれている場合は即座に実行
      this.setupCartPageEvents();
      this.fetchCartAndUpdateCount();
      this.updateCartPageButtonsState();
    }
  }

  bindEvents() {
    // カートに追加ボタンのイベント
    document.addEventListener("submit", (e) => {
      if (e.target.classList.contains("cart-form")) {
        e.preventDefault();
        this.addToCart(e.target);
      }
    });

    // バリエーション選択の変更イベント
    document.addEventListener("change", (e) => {
      if (e.target.classList.contains("variant-option-select")) {
        this.updateVariantSelection(e.target.closest(".cart-form"));
      }
    });

    // 商品詳細ページの数量変更ボタン
    document.addEventListener("click", (e) => {
      const form = e.target.closest(".cart-form");
      if (!form) return;

      if (e.target.classList.contains("quantity-increase")) {
        e.preventDefault();

        // ボタンが無効化されている場合は処理しない
        if (e.target.disabled || e.target.classList.contains("disabled")) {
          return;
        }

        const quantityInput = form.querySelector(".quantity-input");
        const button = form.querySelector(".add-to-cart-btn");

        if (quantityInput && button) {
          const currentValue = parseInt(quantityInput.value, 10) || 1;
          const variantId = form.querySelector("#selected-variant-id")?.value || button.dataset.variantId;
          const maxInventory = button.dataset.maxInventory ? parseInt(button.dataset.maxInventory, 10) : null;

          // 現在のカート内の数量をチェック
          const existingItem = this.cart.find((item) => item.variantId === variantId);
          const currentCartQuantity = existingItem ? existingItem.quantity : 0;
          const totalQuantity = currentValue + currentCartQuantity;

          // 在庫チェック
          if (maxInventory !== null && totalQuantity >= maxInventory) {
            alert(`在庫上限に達しています。`);
            return;
          }

          quantityInput.value = currentValue + 1;

          // 数量変更後に再度在庫チェックしてボタンを無効化
          const newTotalQuantity = currentValue + 1 + currentCartQuantity;
          if (maxInventory !== null && newTotalQuantity >= maxInventory) {
            e.target.disabled = true;
            e.target.classList.add("disabled");
          }
        }
      } else if (e.target.classList.contains("quantity-decrease")) {
        e.preventDefault();
        const quantityInput = form.querySelector(".quantity-input");
        const button = form.querySelector(".add-to-cart-btn");
        const quantityIncreaseBtn = form.querySelector(".quantity-increase");

        if (quantityInput) {
          const currentValue = parseInt(quantityInput.value, 10) || 1;
          quantityInput.value = Math.max(1, currentValue - 1);

          // 数量減少後、増加ボタンの状態を更新
          if (quantityIncreaseBtn && button) {
            const newValue = parseInt(quantityInput.value, 10);
            const variantId = form.querySelector("#selected-variant-id")?.value || button.dataset.variantId;
            const maxInventory = button.dataset.maxInventory ? parseInt(button.dataset.maxInventory, 10) : null;

            if (maxInventory !== null) {
              const existingItem = this.cart.find((item) => item.variantId === variantId);
              const currentCartQuantity = existingItem ? existingItem.quantity : 0;
              const totalQuantity = newValue + currentCartQuantity;

              if (totalQuantity >= maxInventory) {
                quantityIncreaseBtn.disabled = true;
                quantityIncreaseBtn.classList.add("disabled");
              } else {
                quantityIncreaseBtn.disabled = false;
                quantityIncreaseBtn.classList.remove("disabled");
              }
            } else {
              quantityIncreaseBtn.disabled = false;
              quantityIncreaseBtn.classList.remove("disabled");
            }
          }
        }
      }
    });

    // ドロワーを閉じる
    document.addEventListener("click", (e) => {
      const drawer = document.getElementById("cart-drawer");
      if (e.target.classList.contains("cart-drawer-overlay") || e.target.classList.contains("cart-drawer-close")) {
        this.closeDrawer();
      }
    });

    document.querySelectorAll(".cart-drawer-close").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeDrawer();
      });
    });

    document.querySelectorAll(".cart-btn").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        this.openDrawer();
      });
    });

    // 数量変更
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("quantity-btn")) {
        const action = e.target.dataset.action;
        const variantId = e.target.dataset.variantId;
        const key = e.target.dataset.key;

        // カートドロワーの場合はShopifyのキーを使用
        if (key) {
          this.updateQuantityByKey(key, action);
        } else {
          this.updateQuantity(variantId, action);
        }
      }

      if (e.target.classList.contains("cart-item-remove")) {
        const variantId = e.target.dataset.variantId;
        const key = e.target.dataset.key;

        // カートドロワーの場合はShopifyのキーを使用
        if (key) {
          this.removeItemByKey(key);
        } else {
          this.removeItem(variantId);
        }
      }
    });

    // チェックアウト
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("cart-checkout-btn")) {
        this.checkout();
      }
    });

    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  }

  getHeight() {
    const height1 = Math.ceil(document.querySelector(".cart-drawer-content .inner").getBoundingClientRect().height);
    const height2 = document.querySelector(".cart-drawer-footer").getBoundingClientRect().height;
    gsap.set("#cart-drawer .scroller", {
      height: window.innerHeight - height1 - height2,
    });
    gsap.set("#cart-drawer #cart-items", {
      height: window.innerHeight - height1 - height2 + 1,
    });
  }

  updateVariantSelection(form) {
    if (!form) return;

    const variantsJson = document.getElementById("product-variants-json");
    if (!variantsJson) return;

    const variants = JSON.parse(variantsJson.textContent);
    const variantSelects = form.querySelectorAll(".variant-option-select");

    // 選択されたオプション値を取得
    const selectedOptions = Array.from(variantSelects).map((select) => select.value);

    // 選択されたオプションに一致するバリアントを検索
    const selectedVariant = variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    if (!selectedVariant) return;

    // selected-variant-idを更新
    const variantIdInput = form.querySelector("#selected-variant-id");
    if (variantIdInput) {
      variantIdInput.value = selectedVariant.id;
    }

    // ボタンのdata属性を更新
    const button = form.querySelector(".add-to-cart-btn");
    if (button) {
      button.dataset.variantId = selectedVariant.id;
      button.dataset.variantPrice = selectedVariant.price;
      if (selectedVariant.inventory_management) {
        button.dataset.maxInventory = selectedVariant.inventory_quantity;
      } else {
        delete button.dataset.maxInventory;
      }
    }

    // 価格表示を更新
    const priceElement = form.closest(".info")?.querySelector(".price p");
    if (priceElement && selectedVariant.price) {
      priceElement.textContent = selectedVariant.price;
    }

    // 在庫表示を更新
    const inventoryElement = form.closest(".info")?.querySelector(".inventory-quantity");
    const inventoryCountElement = form.closest(".info")?.querySelector(".inventory-quantity-count");
    if (selectedVariant.inventory_management && selectedVariant.inventory_quantity !== null) {
      if (inventoryElement) {
        inventoryElement.classList.toggle("show", selectedVariant.inventory_quantity <= 5);
      }
      if (inventoryCountElement) {
        inventoryCountElement.textContent = selectedVariant.inventory_quantity;
      }
    }

    // 数量増加ボタンの無効化
    const quantityInput = form.querySelector(".quantity-input");
    const quantityIncreaseBtn = form.querySelector(".quantity-increase");
    if (quantityIncreaseBtn && quantityInput) {
      const currentQuantity = parseInt(quantityInput.value, 10) || 1;
      const maxInventory = selectedVariant.inventory_management ? selectedVariant.inventory_quantity : null;

      // 現在のカート内の数量をチェック
      const existingItem = this.cart.find((item) => item.variantId === selectedVariant.id.toString());
      const currentCartQuantity = existingItem ? existingItem.quantity : 0;
      const totalQuantity = currentQuantity + currentCartQuantity;

      if (maxInventory !== null && totalQuantity >= maxInventory) {
        quantityIncreaseBtn.disabled = true;
        quantityIncreaseBtn.classList.add("disabled");
      } else {
        quantityIncreaseBtn.disabled = false;
        quantityIncreaseBtn.classList.remove("disabled");
      }
    }
  }

  async addToCart(form) {
    const button = form.querySelector(".add-to-cart-btn");

    // フォームから最新のバリアントIDを取得
    const variantIdInput = form.querySelector("#selected-variant-id");
    const variantId = variantIdInput ? variantIdInput.value : button.dataset.variantId;

    // フォームから数量を取得
    const quantityInput = form.querySelector(".quantity-input");
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    // バリエーション情報を取得
    const variantsJson = document.getElementById("product-variants-json");
    let selectedVariant = null;
    if (variantsJson) {
      const variants = JSON.parse(variantsJson.textContent);
      selectedVariant = variants.find((v) => v.id.toString() === variantId.toString());
    }

    // 商品情報を取得（バリエーション変更時に対応）
    let productTitle = button.dataset.productTitle;
    let productImage = button.dataset.productImage;
    let variantPrice = selectedVariant ? selectedVariant.price : button.dataset.variantPrice;
    const maxInventory = selectedVariant && selectedVariant.inventory_management ? selectedVariant.inventory_quantity : parseInt(button.dataset.maxInventory) || null;

    // 現在のカート内の数量をチェック
    const existingItem = this.cart.find((item) => item.variantId === variantId);
    const currentQuantity = existingItem ? existingItem.quantity : 0;

    // 在庫チェック
    if (maxInventory !== null && currentQuantity + quantity > maxInventory) {
      alert(`在庫上限に達しています。`);
      return;
    }

    // ローディング状態
    const originalText = button.textContent;
    button.textContent = "Adding to Cart...";
    button.disabled = true;

    try {
      // Shopify Cart APIを使用して商品をカートに追加
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
        }),
      });

      if (response.ok) {
        // ローカルカートに追加
        if (existingItem) {
          existingItem.quantity += quantity;
        } else {
          this.cart.push({
            variantId,
            title: productTitle,
            image: productImage,
            price: variantPrice,
            quantity: quantity,
            maxInventory: maxInventory,
          });
        }

        // 既存アイテムにも在庫情報を更新
        if (existingItem && maxInventory) {
          existingItem.maxInventory = maxInventory;
        }

        this.saveCart();
        await this.updateCartDisplay();

        // 商品詳細ページの数量増加ボタンの状態を更新
        const form = document.querySelector(".cart-form");
        if (form) {
          const quantityInput = form.querySelector(".quantity-input");
          const quantityIncreaseBtn = form.querySelector(".quantity-increase");
          if (quantityIncreaseBtn && quantityInput) {
            const currentValue = parseInt(quantityInput.value, 10) || 1;
            const newCartQuantity = existingItem ? existingItem.quantity + quantity : quantity;
            const totalQuantity = currentValue + newCartQuantity;

            if (maxInventory !== null && totalQuantity >= maxInventory) {
              quantityIncreaseBtn.disabled = true;
              quantityIncreaseBtn.classList.add("disabled");
            }
          }
        }

        this.openDrawer();
        this.showSuccessMessage();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.description || "カートへの追加に失敗しました");
      }
    } catch (error) {
      console.error("エラー:", error);
      if (error.message.includes("enough inventory")) {
        alert("在庫が不足しています。");
      } else {
        alert(error.message || "カートへの追加に失敗しました");
      }
    } finally {
      button.textContent = originalText;
      button.disabled = false;
    }
  }

  async updateQuantity(variantId, action) {
    const item = this.cart.find((item) => item.variantId === variantId);
    if (!item) return;

    let newQuantity = item.quantity;

    if (action === "increase") {
      newQuantity += 1;

      // 在庫チェック
      if (item.maxInventory && newQuantity > item.maxInventory) {
        alert(`在庫上限に達しています。`);
        return;
      }

      // Shopifyの在庫もチェック
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (errorData.description && errorData.description.includes("inventory")) {
            alert("在庫が不足しています。");
            return;
          }
        }
      } catch (error) {
        console.error("在庫チェックエラー:", error);
        alert("在庫確認中にエラーが発生しました。");
        return;
      }

      item.quantity = newQuantity;
    } else if (action === "decrease") {
      item.quantity = Math.max(1, item.quantity - 1);
    }

    this.saveCart();
    this.updateCartDisplay();
    this.syncWithShopifyCart();
  }

  removeItem(variantId) {
    this.cart = this.cart.filter((item) => item.variantId !== variantId);
    this.saveCart();
    this.updateCartDisplay();
    this.syncWithShopifyCart();
  }

  async updateQuantityByKey(key, action) {
    try {
      // 現在のカート情報を取得
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      const cartItem = cart.items.find((item) => item.key === key);
      if (!cartItem) {
        console.error("カートアイテムが見つかりません");
        return;
      }

      let newQuantity = cartItem.quantity;

      if (action === "increase") {
        newQuantity += 1;
      } else if (action === "decrease") {
        newQuantity = Math.max(0, newQuantity - 1);
      }

      // Shopifyカートを直接更新
      await this.updateCartPage(key, newQuantity);
    } catch (error) {
      console.error("数量更新エラー:", error);
    }
  }

  async removeItemByKey(key) {
    try {
      await this.updateCartPage(key, 0);
    } catch (error) {
      console.error("アイテム削除エラー:", error);
    }
  }

  async updateCartDisplay() {
    // Shopifyのカートから最新データを取得してドロワーを更新
    try {
      const response = await fetch("/cart.js");
      const shopifyCart = await response.json();

      // Shopifyカートデータをローカル形式に変換
      this.cart = shopifyCart.items.map((item) => ({
        variantId: item.variant_id.toString(),
        title: item.product_title,
        image: item.image,
        price: this.formatPrice(item.price),
        quantity: item.quantity,
        key: item.key,
        maxInventory: item.variant ? item.variant.inventory_quantity : null,
        variantTitle: item.variant_title || null,
        properties: item.properties || [],
      }));

      // ローカルストレージも更新
      this.saveCart();

      // ドロワー表示を更新
      this.renderCartDrawer();

      // メニューのカート数を更新
      this.updateMenuCartCount(shopifyCart.item_count);

      // document.getElementById("cursor").classList.remove("is-loading");
    } catch (error) {
      console.error("カート表示更新エラー:", error);
      // フォールバック: ローカルカートで表示
      this.renderCartDrawer();
      this.updateMenuCartCount();
    }
  }

  renderCartDrawer() {
    const cartItems = document.getElementById("cart-items");
    const cartEmpty = document.querySelector(".cart-empty");
    const cartTotal = document.getElementById("cart-total-price");

    if (this.cart.length === 0) {
      if (cartItems) cartItems.innerHTML = "";
      if (cartEmpty) cartEmpty.style.display = "block";
      if (cartTotal) cartTotal.textContent = "¥0";
      return;
    }

    if (cartEmpty) cartEmpty.style.display = "none";
    if (cartItems) {
      cartItems.innerHTML = this.cart
        .map(
          (item) => `
      <div class="cart-item">
        <div class="cart-item-image">
          <img src="${item.image}" alt="${item.title}" loading="lazy">
        </div>
        <div class="cart-item-details">
          <h4 class="cart-item-title">${item.title}</h4>
          ${item.variantTitle ? `<p class="cart-item-variant">${item.variantTitle}</p>` : ""}
          ${item.properties && item.properties.length > 0 ? item.properties.map((prop) => (prop.name && prop.value ? `<p class="cart-item-property">${prop.name}: ${prop.value}</p>` : "")).join("") : ""}
          <div class="cart-item-flex">
            <div class="cart-item-quantity">
              <button class="quantity-btn minus" data-action="decrease" data-variant-id="${item.variantId}" data-key="${item.key}"></button>
              <span>${item.quantity}</span>
              <button class="quantity-btn plus ${item.maxInventory && item.quantity >= item.maxInventory ? "disabled" : ""}" data-action="increase" data-variant-id="${item.variantId}" data-key="${item.key}" ${item.maxInventory && item.quantity >= item.maxInventory ? "disabled" : ""}></button>
            </div>
            ${item.maxInventory && item.quantity >= item.maxInventory ? `<div class="cart-item-stock-warning">在庫上限に達しています</div>` : ""}
            ${item.maxInventory && item.maxInventory <= 10 ? `<div class="cart-item-stock-info">残り${item.maxInventory}個</div>` : ""}
            <p class="cart-item-price">${item.price}</p>
          </div>
        </div>
        <button class="cart-item-remove" data-variant-id="${item.variantId}" data-key="${item.key}"></button>
      </div>
    `
        )
        .join("");
    }

    // 合計金額を計算
    const total = this.cart.reduce((sum, item) => {
      const price = parseInt(item.price.replace(/[¥,]/g, ""));
      return sum + price * item.quantity;
    }, 0);

    if (cartTotal) cartTotal.textContent = `¥${total.toLocaleString()}`;
  }

  formatPrice(priceInCents) {
    return `¥${(priceInCents / 100).toLocaleString()}`;
  }

  updateMenuCartCount(count = null) {
    const cartCountElements = document.querySelectorAll(".cart-item-count");
    cartCountElements.forEach((element) => {
      if (count !== null) {
        element.textContent = count;
      } else {
        // ローカルカートから計算
        const totalItems = this.cart.reduce((sum, item) => sum + item.quantity, 0);
        element.textContent = totalItems;
      }
    });
  }

  async openDrawer() {
    // ドロワーを開く前に最新のカートデータを取得
    document.getElementById("cart-drawer").classList.add("open");
    document.body.style.overflow = "hidden";
    // this.lenis.stop();
    await this.updateCartDisplay();
  }

  closeDrawer() {
    document.getElementById("cart-drawer").classList.remove("open");
    document.body.style.overflow = "";
    // this.lenis.start();
  }

  showSuccessMessage() {
    const message = document.createElement("div");
    message.className = "cart-add-success";
    message.textContent = "カートに追加されました！";
    document.querySelector("#cart-drawer .cart-drawer-content").appendChild(message);

    setTimeout(() => message.classList.add("show"), 100);
    setTimeout(() => {
      message.classList.remove("show");
      // setTimeout(() => document.body.removeChild(message), 300);
    }, 2000);
  }

  async syncWithShopifyCart() {
    // Shopifyのカートと同期
    try {
      const updates = {};
      this.cart.forEach((item) => {
        updates[item.variantId] = item.quantity;
      });

      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });
    } catch (error) {
      console.error("カート同期エラー:", error);
    }
  }

  async checkout() {
    // カートが空の場合はチェックアウトできない
    if (this.cart.length === 0) {
      // Shopifyのカートも確認
      try {
        const response = await fetch("/cart.js");
        const shopifyCart = await response.json();
        if (shopifyCart.item_count === 0) {
          alert("カートが空です。");
          return;
        }
      } catch (error) {
        console.error("カート確認エラー:", error);
        if (this.cart.length === 0) {
          alert("カートが空です。");
          return;
        }
      }
    }

    // 決済画面に直接遷移
    window.location.href = "/checkout";
  }

  saveCart() {
    localStorage.setItem("cart-drawer-data", JSON.stringify(this.cart));
  }

  loadCart() {
    const saved = localStorage.getItem("cart-drawer-data");
    if (saved) {
      this.cart = JSON.parse(saved);
      this.updateCartDisplay();
    }
  }

  // カートページ専用メソッド
  setupCartPageEvents() {
    const mainCartSection = document.querySelector('[data-section-type="main-cart-items"]');
    if (!mainCartSection) {
      console.log("メインカートセクションが見つかりません");
      return;
    }

    console.log("カートページイベントを設定しました");

    // カートページの数量変更・削除イベント
    mainCartSection.addEventListener("click", (event) => {
      let targetButton = event.target;

      if (targetButton && targetButton.classList.contains("quantity-btn")) {
        console.log("数量ボタンがクリックされました:", targetButton.name);

        const button = targetButton;
        const key = button.dataset.key;
        const quantityElement = button.parentElement.querySelector(".quantity-num");
        let quantity = parseInt(quantityElement.textContent, 10);

        console.log("現在の数量:", quantity, "キー:", key);

        if (button.name === "plus") {
          // ボタンが無効化されている場合は処理しない
          if (button.disabled || button.classList.contains("disabled")) {
            return;
          }
          // 在庫チェックのため、まず現在のカート情報を取得
          this.checkInventoryAndUpdateCartPage(key, quantity + 1);
        } else if (button.name === "minus" && quantity > 0) {
          quantity--;
          console.log("新しい数量:", quantity);
          this.updateCartPage(key, quantity);
        }
      }

      // 削除処理も同様にSVGクリックを考慮
      let removeButton = event.target;
      if (event.target.tagName === "svg" || event.target.tagName === "path") {
        removeButton = event.target.closest(".cart-item-remove-button");
      }

      if (removeButton && removeButton.classList.contains("cart-item-remove-button")) {
        console.log("削除ボタンがクリックされました");
        const key = removeButton.dataset.key;
        if (key) {
          this.updateCartPage(key, 0);
        }
      }
    });
  }

  fetchCartAndUpdateCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        this.updateMenuCartCount(cart.item_count);
      })
      .catch((e) => {
        console.error("Error fetching cart count:", e);
      });
  }

  async checkInventoryAndUpdateCartPage(key, newQuantity) {
    try {
      // 現在のカート情報を取得して在庫をチェック
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      const cartItem = cart.items.find((item) => item.key === key);
      if (!cartItem) {
        console.error("カートアイテムが見つかりません");
        return;
      }

      // バリアントの在庫情報を取得
      const productResponse = await fetch(`/products/${cartItem.handle}.js`);
      const product = await productResponse.json();

      const variant = product.variants.find((v) => v.id === cartItem.variant_id);
      if (!variant) {
        console.error("バリアントが見つかりません");
        return;
      }

      // 在庫チェック
      if (variant.inventory_management && variant.inventory_quantity !== null) {
        if (newQuantity > variant.inventory_quantity) {
          alert(`在庫上限に達しています。`);
          return;
        }
      }

      console.log("新しい数量:", newQuantity);
      this.updateCartPage(key, newQuantity);
    } catch (error) {
      console.error("在庫チェックエラー:", error);
      // エラーが発生した場合でも数量変更は実行（Shopify側でエラーになる場合もある）
      this.updateCartPage(key, newQuantity);
    }
  }

  updateCartPage(key, quantity) {
    // document.getElementById("cursor").classList.add("is-loading");

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorData) => {
            const error = new Error(errorData.description || errorData.message || "不明なエラーが発生しました。");
            error.status = response.status;
            throw error;
          });
        }
        return response.json();
      })
      .then((data) => {
        if (data.status && (data.status === "error" || data.status === 422)) {
          throw new Error(data.description || "APIエラー");
        }
        this.updateMenuCartCount(data.item_count);

        // カートページが存在する場合はセクションを再レンダリング
        const mainCartSection = document.querySelector('[data-section-type="main-cart-items"]');
        if (mainCartSection) {
          this.renderCartSection().then(() => {
            // セクション再レンダリング後に数量ボタンの無効化状態を更新
            this.updateCartPageButtonsState();
          });
        }

        // カートドロワーも同時に更新
        this.updateCartDisplay();
      })
      .catch((error) => {
        console.error("Error:", error);

        if (error.message && error.message.includes("items were added to your cart due to availability")) {
          alert("在庫上限に達しています。");
        } else {
          alert(`カートの更新中にエラーが発生しました。\n\n詳細: ${error.message}`);
        }
        // document.getElementById("cursor").classList.remove("is-loading");
      });
  }

  renderCartSection() {
    const mainCartSection = document.querySelector('[data-section-type="main-cart-items"]');
    if (!mainCartSection) return Promise.resolve();

    const sectionId = mainCartSection.dataset.sectionId;

    return fetch(`?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((htmlString) => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(htmlString, "text/html");
        const newSection = newDocument.querySelector(`[data-section-id="${sectionId}"]`);

        if (newSection) {
          mainCartSection.innerHTML = newSection.innerHTML;
          // document.getElementById("cursor").classList.remove("is-loading");
        } else {
          window.location.reload();
        }
      })
      .catch((e) => {
        console.error("Section render error:", e);
        window.location.reload();
      })
      .finally(() => {
        // document.getElementById("cursor").classList.remove("is-loading");
      });
  }

  async updateCartPageButtonsState() {
    try {
      // 現在のカート情報を取得
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      // 各カートアイテムの数量ボタンの状態を更新
      const updatePromises = cart.items.map(async (cartItem) => {
        try {
          // カートアイテムの行を検索（data-key属性またはvariant-idで検索）
          const cartItemRow = document.querySelector(`[data-key="${cartItem.key}"]`)?.closest(".cart-item") || document.querySelector(`[data-variant-id="${cartItem.variant_id}"]`)?.closest(".cart-item");

          if (!cartItemRow) {
            // フォールバック: カートページの数量ボタンを直接検索
            const quantityBtn = document.querySelector(`.quantity-btn[name="plus"][data-key="${cartItem.key}"]`);
            if (!quantityBtn) return;

            // バリアントの在庫情報を取得
            const productResponse = await fetch(`/products/${cartItem.handle}.js`);
            const product = await productResponse.json();
            const variant = product.variants.find((v) => v.id === cartItem.variant_id);
            if (!variant) return;

            // 在庫チェック
            if (variant.inventory_management && variant.inventory_quantity !== null) {
              if (cartItem.quantity >= variant.inventory_quantity) {
                quantityBtn.disabled = true;
                quantityBtn.classList.add("disabled");
              } else {
                quantityBtn.disabled = false;
                quantityBtn.classList.remove("disabled");
              }
            } else {
              quantityBtn.disabled = false;
              quantityBtn.classList.remove("disabled");
            }
            return;
          }

          // カートアイテム行内の数量増加ボタンを検索
          const quantityBtn = cartItemRow.querySelector('.quantity-btn[name="plus"]') || cartItemRow.querySelector(".quantity-btn.plus");

          if (!quantityBtn) return;

          // バリアントの在庫情報を取得
          const productResponse = await fetch(`/products/${cartItem.handle}.js`);
          const product = await productResponse.json();
          const variant = product.variants.find((v) => v.id === cartItem.variant_id);
          if (!variant) return;

          // 在庫チェック
          if (variant.inventory_management && variant.inventory_quantity !== null) {
            if (cartItem.quantity >= variant.inventory_quantity) {
              quantityBtn.disabled = true;
              quantityBtn.classList.add("disabled");
            } else {
              quantityBtn.disabled = false;
              quantityBtn.classList.remove("disabled");
            }
          } else {
            quantityBtn.disabled = false;
            quantityBtn.classList.remove("disabled");
          }
        } catch (error) {
          console.error(`カートアイテム ${cartItem.key} のボタン状態更新エラー:`, error);
        }
      });

      await Promise.all(updatePromises);
    } catch (error) {
      console.error("カートページボタン状態更新エラー:", error);
    }
  }
}

export default Cart;
